export default {
  general_permissions_tab_subtitle:
    'Cette section décrit les autorisations générales du système pour cet utilisateur dans ce programme',
  duet_permissions_tab_subtitle:
    'Cette section décrit les autorisations liées à Duet',
  snapshot_permissions_tab_subtitle:
    'Cette section décrit les autorisations liées à Snapshot',
  casper_permissions_tab_subtitle:
    'Cette section décrit les autorisations liées à Casper',
  analytics_permissions_tab_subtitle:
    'Voici les types de contenu que cet utilisateur peut visualiser dans Analytics',
  permissions_tab_data_types: 'Types de données',
  permissions_tab_data_filters: 'Filtres de données',
  permissions_tab_data_filters_subtitle:
    'Cette section décrit les sous-ensembles de données auxquels un utilisateur peut accéder',
  permissions_tab_data_filters_no_access: 'Aucun accès',
  permissions_tab_data_filters_no_access_description:
    "Cet utilisateur ne peut voir aucun dossier. Tout tableau de bord auquel cet utilisateur a été autorisé à accéder (via les types de données) ne sera pas rempli de dossiers pour le moment. L'accès aux données doit être défini pour permettre à cet utilisateur de consulter les dossiers.",
  permissions_tab_data_filters_unrestricted_access: 'Accès illimité',
  permissions_tab_data_filters_unrestricted_access_description:
    'Cet utilisateur peut voir tous les dossiers. Tout tableau de bord auquel cet utilisateur a accès (via les types de données) sera entièrement rempli de tous les dossiers disponibles. Tout nouvel dossier sera automatiquement rendu accessible à cet utilisateur.',
  analytics_help_text:
    'Besoin d`aide ? En savoir plus sur les types de données et les filtres',
  save_general_permissions: 'Enregistrer les autorisations générales',
  save_duet_permissions: 'Enregistrer les autorisations Duet',
  save_snapshot_permissions: 'Enregistrer les autorisations Snapshot',
  save_casper_permissions: 'Enregistrer les autorisations Casper',
  save_analytics_permissions: 'Enregistrer les autorisations Analytics',
  general_permissions_title: 'Autorisations générales',
  duet_permissions_title: 'Autorisations Duet',
  snapshot_permissions_title: 'Autorisations Snapshot',
  casper_permissions_title: 'Autorisations Casper',
  analytics_permissions_title: 'Autorisations Analytics',
  feature_category_title: 'Fonctionnalités',
  data_category_title: 'Types de données',
  data_category_subtitle_analytics:
    'Voici les types de contenu que cet utilisateur peut visualiser dans Analytics.',
  navigation_confirmation_title: 'Vous avez des modifications non sauvegardées',
  navigation_confirmation_description_line_1:
    "Si vous quittez le site ou changez d'onglet, vos modifications seront perdues.",
  navigation_confirmation_description_line_2:
    'Voulez-vous rester et continuer à éditer, ou quitter sans sauvegarder ?',
  navigation_confirmation_stay: 'Rester',
  navigation_confirmation_leave_without_saving: 'Quitter sans sauvegarder',
  save_permissions_duration:
    "Les mises à jour des autorisations peuvent prendre jusqu'à 15 minutes pour être reflétées dans l'ensemble du système.",
  save_permissions_success_toast_message:
    'Vos modifications ont été sauvegardées.',
  save_permissions_error_toast_message:
    "Quelque chose a mal tourné. Vos modifications n'ont pas pu être sauvegardées. Veuillez réessayer.",
  no_program_permissions:
    "Cet utilisateur n'a aucune autorisation attribuée à ce programme. Attribuer des autorisations pour que l'utilisateur puisse accéder à ce programme.",
  program_permissions: 'Autorisations du programme',
  unrestricted_access_summary:
    '<b>{{name}}</b> a un <b>accès complet</b> aux dossiers appartenant aux <b>types de données pour lesquels les autorisations ont été accordées</b> ci-dessus. Cet utilisateur peut consulter les dossiers pour les types de données auxquels il est autorisé pour :',
  unrestricted_access_summary_description:
    "TOUS <b>les Apprenant(e)s</b><br />ET<br />TOUS <b>les Activités d'apprentissage</b>",
  data_filter_description:
    "Les filtres suivants sont utilisés pour définir l'accès aux données granulaires pour <b>{{name}}</b>. Lorsque des options de filtre sont sélectionnées, le résumé du filtre de données à gauche reflétera la façon dont ces filtres fonctionnent ensemble. Pour accorder à cet utilisateur un accès illimité, décochez les options ci-dessous.",
  filter_data_by_learner:
    "Filtrer l'accès aux données par attributs « apprenant(e) »",
  filter_data_by_learning_events:
    "Filtrer l'accès aux données par attributs « Activité d'apprentissage »",
  manage_data_filters: 'Gestion des filtres',
  restricted_access_summary:
    "<b>{{name}}</b> n'a <b>pas accès</b> aux dossiers appartenant aux <b>types de données pour lesquels les autorisations ont été accordées</b> ci-dessus. Cet utilisateur ne peut consulter <b>aucune</b> donnée. Retirez ou sélectionnez les filtres à droite pour accorder un accès complet ou limité.",
  limited_access_summary:
    '<b>{{name}}</b> a un <b>accès limité</b> aux dossiers appartenant aux <b>types de données pour lesquels les autorisations ont été accordées</b> ci-dessus. Cet utilisateur peut consulter les dossiers pour les types de données auxquels il est autorisé lorsque :',
  filter_access_warning:
    "L'activation des filtres de données et la non-sélection des apprenants ou des activités d'apprentissage empêcheront l'utilisateur d'accéder à TOUTES les données.",
  filter_access_alert:
    "Lors de l'enregistrement des autorisations Analytics, cette section de filtrage des données sera désactivée car il n'y a pas de sélection de filtre en cours.",
  confirm_uncheck_filter_title: 'Confirmer',
  confirm_uncheck_filter_body:
    'Êtes-vous sûr de vouloir décocher cette section ? Cette action effacera tous les attributs « {{filterType}} ».',
  filter_type_learner: 'Apprenant',
  filter_type_learning_event: "Activité d'apprentissage",
  add_to_program: 'Ajouter au(x) programme(s)',
  create_new_user: 'Créer un nouvel utilisateur',
  create_new_admin: 'Créer un nouvel administrateur',
  create_admin_account: 'Créer un compte administrateur',
  create_user_account: 'Créer un compte utilisateur',
  add_program_access: 'Ajouter accès au(x) programme(s)',
  add_program_access_description:
    "Ajouter un programme permet à cet utilisateur d'accéder aux produits et aux données spécifiques à ce programme. Après avoir ajouté le(s) programme(s), il est nécessaire d'attribuer des autorisations spécifiques pour s'assurer qu'ils ont l'accès approprié.",
  add_program_access_success: '{{name}} ajouté avec succès à {{programs}}',
  add_program_access_error:
    "L'ajout de {{name}} à {{programs} a échoué. Veuillez réessayer ou contactez l'équipe de soutien si le problème persiste.",
  remove_program_access: 'Supprimer accès au programme',
  remove_program_access_description:
    "Voulez-vous vraiment supprimer l'accès de {{name}} ⁠à {{program}} ? Cette action supprimera toutes les permissions associées à ce programme et l'utilisateur ne pourra plus accéder à aucun contenu connexe.",
  remove_access: "Supprimer l'accès",
  remove_program_access_success:
    "L'accès de {{name}} au {{program}} a été supprimé avec succès.",
  remove_program_access_error:
    "Une erreur s'est produite. Impossible de supprimer l'accès. Veuillez réessayer.",
  no_programs_assigned:
    'Aucun programme attribué. Ajoutez cet utilisateur à un programme pour gérer ses autorisations.',
  impersonation_error: "Échec de l'émulation d'utilisateur!",
  create_admin_alert_description:
    "Cette action créera un utilisateur administrateur ayant accès à TOUS LES PROGRAMMES et aux outils spéciaux réservés aux employés d'Acuity Insights. Ce type d'utilisateur doit être utilisé exclusivement par le personnel d'Acuity Insights ! Les comptes d'administrateur doivent avoir une adresse courriel se terminant par le domaine « acuityinsights.com » pour pouvoir se connecter avec succès.",
  create_admin_success: 'Le compte administrateur a été créé avec succès.',
  create_user_success: 'Le compte utilisateur a été créé avec succès.',
  create_analytics_account_prompt:
    'Cet utilisateur utilisera le produit « Analytics » dans un ou plusieurs des programmes sélectionnés.',
  no_users_selected_tooltip:
    'Veuillez sélectionner au moins un utilisateur à exporter.',
  removing_archived: "La suppression du rôle 'archivé' activera ce compte.",
  adding_archived: "L'ajout du rôle 'archivé' désactivera ce compte.",
  confirm: 'Voulez-vous vraiment continuer?',
  user_roles_admin: 'admin',
  user_roles_school_admin: 'admin-établissement',
  user_roles_team_member: 'membre-équipe',
  user_roles_archived: 'archivé',
  user_roles_rater: 'évaluateur',
  user_roles_reviewer: 'examinateur',
  user_roles_formative: 'formative',
  last_invite_sent: 'Dernière invitation envoyée',
  successful: 'avec succès',
  failed: 'échoué'
};
